import { render, staticRenderFns } from "./produceSearch.vue?vue&type=template&id=54ef80f1&scoped=true&"
import script from "./produceSearch.vue?vue&type=script&lang=js&"
export * from "./produceSearch.vue?vue&type=script&lang=js&"
import style0 from "./produceSearch.vue?vue&type=style&index=0&id=54ef80f1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ef80f1",
  null
  
)

export default component.exports